module.exports = __webpack_public_path__ + "img/logo.5e74bef8.webp";